import {useContext, useEffect, useRef, useState} from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import './Chart.scss';
import {authContext} from '../Context/Authentication/authContext';

am4core.addLicense('CH332271218');

am4core.useTheme(am4themes_animated);

const randColor = () => {
  return (
    '#' +
    Math.floor(Math.random() * 16777215)
      .toString(16)
      .padStart(6, '0')
      .toUpperCase()
  );
};

const getText = (selectedOption: string, selectedTab: string) => {
  const removePredictionTextFor = ['Population', 'Permits']

  const text = <div className='char-list-items'>
    <ol>
      <li className="chart-list"><span className="heading">Total Buildings: </span>The plot shows permits issued for total buildings each month.</li>
      <li className="chart-list"><span className="heading">Total Units: </span>The plot shows permits issued for total units each month.</li>
      <li className="chart-list"><span className="heading">Total Valuation ($): </span>The plot shows permits issued for total valuation in dollar.</li>
      <li className="chart-list"><span className="heading">One Unit: </span>The plot shows permits issued for 1–units each month. (Each building accommodates a single family).</li>
      <li className="chart-list"><span className="heading">One Unit Valuation ($): </span>The plot shows one-unit permits issued for valuation in dollars.</li>
      <li className="chart-list"><span className="heading">Two Units: </span>The plot shows permits issued for 2 - units each month. (Each building accommodates two families).</li>
      <li className="chart-list"><span className="heading">Two Units Valuation ($): </span>The plot shows two-unit permits issued for valuation in dollars.</li>
      <li className="chart-list"><span className="heading">Three to Four Units: </span>The plot shows permits issued for 3 to 4 - units each month. (Each building accommodates three or four families).</li>
      <li className="chart-list"><span className="heading">Three to Four Units Valuation ($): </span>The plot shows three or four-unit permits issued for valuation in dollar.</li>
      <li className="chart-list"><span className="heading">More Than Five Unit: </span>The plot shows permits issued for more than 5 or more units each month. Each building accommodates five or more families).</li>
      <li className="chart-list"><span className="heading">More Than Five Unit Valuation ($): </span>The plot shows five or more-unit permits issued for valuation in dollars.</li>
      <li className="chart-list"><span className="heading">Total Units Vs Total Valuation ($): </span>The line plot shows permits issued for total units each month and bar plot show valuation of those units.</li>
      <li className="chart-list"><span className="heading">One Unit Vs One Unit Valuation ($): </span>The line plot shows permits issued for 1-units each month and bar plot show valuation of those units.</li>
      <li className="chart-list"><span className="heading">Two Units Vs Two Units Valuation ($): </span>The line plot shows permits issued for 2-units each month and bar plot show valuation of those units.</li>
      <li className="chart-list"><span className="heading">Three To Four Units Vs Three To Four Units Valuation ($): </span>The line plot shows permits issued for 3- or 4-units each month and bar plot show valuation of those units.</li>
      <li className="chart-list"><span className="heading">More Than Five Units Vs More Than Five Units Valuation ($): </span>The line plot shows permits issued for 5- or more units each month and bar plot show valuation of those units.</li>
    </ol>
  </div>

  return <div className='help-text'>
    {!removePredictionTextFor.includes(selectedTab) && (
      <div>Predicted values represented by dashed line.<br/><br/></div>)}
    <span style={{textDecoration: 'underline'}}>Helpful Hints:</span>
    {text}
  </div>
}

const lineColor = '#fff'
const columnColor = '#F7B047'
const white = '#fff'
const golden = '#F7B047'

const ParetoChart = ({
                       chartData,
                       city,
                       info,
                     }: any) => {
  const chartRef: any = useRef(null);
  const {state, dispatch}: any = useContext(authContext);
  const selectedOption = state.filters.selectedType
  const selectedTab = state.selectedTab


  const leftSide = info.leftKey
  const leftTitle = info.leftTitle
  const rightSide = info.rightKey
  const rightTitle = info.rightTitle


  const generateChart = () => {
    const chart = am4core.create('paretoChartDiv', am4charts.XYChart);
    chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd';
    chart.data = chartData

    // Set input format for the dates
    chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd';

    chart.events.on('ready', function () {
      if (state.filters.chartStartDate && state.filters.chartEndDate) {
        dateAxis.zoomToDates(
          new Date(state.filters.chartStartDate),
          new Date(state.filters.chartEndDate)
        );
      }
    });

    // Create axes
    const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.strokeWidth = 1;
    dateAxis.renderer.grid.template.strokeOpacity = 0.3;
    // @ts-ignore
    dateAxis.renderer.grid.template.stroke = '#fff';
    dateAxis.renderer.minGridDistance = 100;
    dateAxis.title.text = 'Date';
    // @ts-ignore
    dateAxis.title.fill = white;
    dateAxis.title.fontSize = 13;
    dateAxis.renderer.labels.template.fontSize = 10;
    dateAxis.title.fontWeight = 'bold';
    dateAxis.dateFormats.setKey('month', 'MMM YYYY');
    // @ts-ignore
    dateAxis.renderer.labels.template.fill = '#fff';

    const dateAxisChanged = (ev: any) => {
      let start = ev.target.minZoomed;
      let end = ev.target.maxZoomed;
      dispatch({
        type: 'APPLY_FILTER',
        payload: {
          ...state.filters,
          chartStartDate: start,
          chartEndDate: end,
        },
      });
    }
    dateAxis.events.on('startchanged', dateAxisChanged);
    dateAxis.events.on('endchanged', dateAxisChanged);


    const leftAxis = chart.yAxes.push(new am4charts.ValueAxis());
    // @ts-ignore
    leftAxis.renderer.grid.template.stroke = white;
    leftAxis.renderer.grid.template.strokeWidth = 1;
    leftAxis.renderer.grid.template.strokeOpacity = 0.3;
    leftAxis.title.text = leftTitle;
    // @ts-ignore
    leftAxis.title.fill = white;
    leftAxis.title.fontSize = 13;
    leftAxis.title.fontWeight = 'bold';
    leftAxis.renderer.labels.template.fontSize = 10;
    // @ts-ignore
    leftAxis.renderer.labels.template.fill = white;
    leftAxis.min = 0;

    const rightAxis = chart.yAxes.push(new am4charts.ValueAxis());
    // @ts-ignore
    rightAxis.renderer.grid.template.stroke = white;
    rightAxis.renderer.grid.template.strokeWidth = 1;
    rightAxis.renderer.grid.template.strokeOpacity = 0.3;
    rightAxis.title.text = rightTitle;
    // @ts-ignore
    rightAxis.title.fill = white;
    rightAxis.title.fontSize = 13;
    rightAxis.title.fontWeight = 'bold';
    rightAxis.renderer.labels.template.fontSize = 10;
    // @ts-ignore
    rightAxis.renderer.labels.template.fill = '#fff';
    rightAxis.renderer.opposite = true;

    // Create series
    const series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueY = leftSide;
    series.dataFields.dateX = 'date';
    series.strokeWidth = 2;
    series.stroke = am4core.color(lineColor)
    series.zIndex = 100;

    const valSeriesRight = chart.series.push(new am4charts.ColumnSeries());
    valSeriesRight.dataFields.valueY = rightSide;
    valSeriesRight.dataFields.dateX = 'date';
    valSeriesRight.columns.template.strokeWidth = 0;
    // @ts-ignore
    valSeriesRight.columns.template.fill = am4core.color(columnColor);
    valSeriesRight.yAxis = rightAxis;

    // Make bullets grow on hover
    const bullet = series.bullets.push(new am4charts.CircleBullet());
    bullet.circle.strokeWidth = 2;
    bullet.circle.radius = 2;
    bullet.circle.fill = am4core.color(lineColor);
    bullet.tooltipHTML = `<div><div><span style='font-weight: bold'>${leftTitle}:</span> {${leftSide}}</div><div><span style='font-weight: bold'>${rightTitle}:</span> {${rightSide}}</div><div><span style="font-weight: bold">Date:</span> {dateX}</div></div>`;

    const scrollbarX = new am4charts.XYChartScrollbar();
    scrollbarX.background.fill = am4core.color(white);
    scrollbarX.background.fillOpacity = 0.2;
    scrollbarX.startGrip.icon.stroke = am4core.color(white);
    scrollbarX.endGrip.icon.stroke = am4core.color(white);

    scrollbarX.series.push(series);
    chart.scrollbarX = scrollbarX;
    chart.scrollbarX.parent = chart.bottomAxesContainer;
    // @ts-ignore
    chart.scrollbarX.startGrip.background.states.getKey('hover').properties.fill = am4core.color(white);
    // @ts-ignore
    chart.scrollbarX.endGrip.background.states.getKey('hover').properties.fill = am4core.color(white);
    chart.scrollbarX.startGrip.background.fill = am4core.color(golden);
    chart.scrollbarX.endGrip.background.fill = am4core.color(golden);
    chart.scrollbarX.thumb.background.fill = am4core.color(golden);
    // @ts-ignore
    let scrollSeries = chart.scrollbarX.scrollbarChart.series.getIndex(0);
    // @ts-ignore
    scrollSeries.stroke = '#000';
    chart.scrollbarX.background.fill = am4core.color(white);
    chart.scrollbarX.background.fillOpacity = 0.2;
    // @ts-ignore
    chart.scrollbarX.unselectedOverlay.fill = am4core.color(white);
    // @ts-ignore
    chart.scrollbarX.unselectedOverlay.fillOpacity = 0.5;

    return chart
  }


  useEffect(() => {
    chartRef.current = generateChart()
    return () => {
      chartRef.current && chartRef.current?.dispose();
    };
  });

  return (
    <>
      <div className='chart-main'>
        <div
          className='chart-main__multilineAreaChart'
          id={'paretoChartDiv'}
          ref={chartRef}
        ></div>
        <div className='chart-main__cityLegendContainer'>
          <div className='chart-main__cityLegendContainer__head'>
            City
          </div>
          <div className='chart-main__cityLegendContainer__cityNameContainer'>
            <div
              className='chart-main__cityLegendContainer__cityNameContainer__inner'
            >
              <div
                className='chart-main__cityLegendContainer__cityNameContainer__inner__circle'
                style={{backgroundColor: golden}}
              ></div>
              <div className='chart-main__cityLegendContainer__cityNameContainer__inner__text' style={{color: golden}}>
                {city}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="chart-main__predictedValueText">
        {getText(selectedOption, selectedTab)}
      </div>
    </>
  );
};

export default ParetoChart;
